module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/middlePlatform/asset/default2.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/middlePlatform/asset/default2.png
// module id = 665
// module chunks = 367